export default "__VITE_ASSET__BR7SE$s___"